<template>
    <div class="bg-white shadow-md rounded-xl p-6 w-full flex flex-col justify-between" style="height: 100%;">
        <!-- Title -->
        <div class="flex justify-between items-center">
            <p class="text-gray-900 font-semibold text-lg">Mobile App Logins</p>
        </div>

        <!-- Donut Chart -->
        <div class="flex justify-center py-4">
            <highcharts :options="pieChartOptions" ref="chart"></highcharts>
        </div>

        <!-- Active User Legend -->
        <div class="flex items-center justify-center text-sm text-gray-600">
            <div class="w-3 h-3 bg-[#1307A8] rounded-full mr-2"></div>
            Active - {{ employeesLength }}
        </div>
    </div>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import Api from "../../../router/api";
import Vue from "vue";

export default {
    components: {
        HighchartsVue,
    },
    data() {
        return {
            employeesLength: 0,
            getEmpData: {
                sortBy: "",
                name: "",
                email: "",
                sortOrder: "",
            },
            pieChartOptions: {
                chart: {
                    type: "pie",
                    width: 160,
                    height: 160,
                    backgroundColor: "transparent",
                },
                title: {
                    text: "",
                },
                plotOptions: {
                    pie: {
                        innerSize: "70%", // Creates the donut effect
                        dataLabels: {
                            enabled: false,
                        },
                    },
                },
                series: [
                    {
                        name: "User",
                        colorByPoint: true,
                        data: [],
                        showInLegend: false,
                    },
                ],
                credits: {
                    enabled: false
                }
            },
        };
    },
    mounted() {
        this.getMobileUsersList();
    },
    methods: {
        getMobileUsersList(page = 1) {
            Api.getMobileUsersList(page, this.getEmpData)
                .then((response) => {
                    this.employeesLength = response.data.res.data.length;
                    const chartData = [
                        { name: "Active", y: this.employeesLength, color: "#090446" },
                        { name: "Inactive", y: 100 - this.employeesLength, color: "#E5E7EB" },
                    ];
                    Vue.set(this.pieChartOptions.series[0], "data", chartData);
                })
                .catch((error) => {
                    this.$swal({
                        icon: "error",
                        title: "Error",
                        text: error.response.data.message || "Something went wrong",
                        showConfirmButton: true,
                    });
                });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/dashboard1/MobileAppLogins.vue